export enum ACTION {
    SET_USER,
    SET_SAVED_JOB,
    SET_JOB_INVITATION,
    SET_IGNORE_JOB_IDS,
    SET_ENABLE_TRACKING_AB,
    SET_TRACKING_PAGE_ZONE,
    SET_SHOW_APPLY_JOB_MODAL,
    SET_SHOW_JOB_MATCHING_MODAL,
    SET_JOB_DETAIL,
    SET_SPECIAL_JOB
}
